import { useDynamicContext, useIsLoggedIn } from "@dynamic-labs/sdk-react-core";
import { BrandLogo } from "./BrandLogo";
import { WalletIcon, ChevronIcon, SunIcon, MoonIcon } from "./Icons";
import { shortAddr } from "@/lib/utils";

interface HeaderProps {
	theme: "light" | "dark";
	onThemeToggle: (t: "light" | "dark") => void;
	onHome?: () => void;
}

export function Header({ theme, onThemeToggle, onHome }: HeaderProps) {
	const { primaryWallet, handleLogOut, setShowAuthFlow, sdkHasLoaded } = useDynamicContext();
	const isLoggedIn = useIsLoggedIn();

	return (
		<header className="topbar">
			<button type="button" className="brand brand-button" onClick={onHome}>
				<BrandLogo theme={theme} />
			</button>

			<div className="topbar-right">
				<div className="theme-toggle-inline" role="group" aria-label="Theme">
					<button
						data-active={theme === "light"}
						onClick={() => onThemeToggle("light")}
						aria-label="Light theme"
					>
						<SunIcon />
					</button>
					<button
						data-active={theme === "dark"}
						onClick={() => onThemeToggle("dark")}
						aria-label="Dark theme"
					>
						<MoonIcon />
					</button>
				</div>

				{!sdkHasLoaded ? (
					<button className="connect-btn" disabled>
						Loading…
					</button>
				) : isLoggedIn && primaryWallet ? (
					<button className="wallet-pill" onClick={() => void handleLogOut()}>
						<WalletIcon />
						<span className="wallet-addr">{shortAddr(primaryWallet.address)}</span>
						<ChevronIcon />
					</button>
				) : (
					<button className="connect-btn" onClick={() => setShowAuthFlow(true)}>
						Connect Wallet
					</button>
				)}
			</div>
		</header>
	);
}
